module.exports = __webpack_public_path__ + "img/client28.e475bdfb.svg";